import logger from '@/lib/logger'

/**
 * Resets session errors during navigation.
 */

export default function({ store }) {
  logger.debug('errorExpiry.js: Checking expiration of errors')

  if (store.state.error.loginAttemptsExpiry <= Date.now()) {
    store.commit('error/resetLoginAttempts')
  }

  if (store.state.error.passwordResetAttemptsExpiry <= Date.now()) {
    store.commit('error/resetPasswordResetAttempts')
  }
}
